"use client";

import Link from "next/link";
import { Button } from "@/app/components/ui/button";
import ContactFormSheet from "@/app/components/forms/contact/contact-form-sheet";
import type { ContactFormSelectOptionT } from "@/app/components/forms/contact/contact-form-types";

type ServiceActionButtonsProps = {
  service: {
    id: string;
    title: string;
    slug: string;
  };
  locationOptions: ContactFormSelectOptionT[];
  makeOptions: ContactFormSelectOptionT[];
  lockedLocationValue?: string;
  appointmentHref: string;
  appointmentLabel: string;
};

/**
 * Service action buttons component that displays contact form and appointment booking buttons
 */
export default function ServiceActionButtons({
  service,
  locationOptions,
  makeOptions,
  lockedLocationValue,
  appointmentHref,
  appointmentLabel,
}: ServiceActionButtonsProps) {
  return (
    <div className="mt-8 flex flex-col gap-4 sm:flex-row">
      <ContactFormSheet
        variant="service"
        variantContext={{
          serviceId: service.id,
          serviceTitle: service.title,
          serviceSlug: service.slug,
        }}
        runtimeSelectOptions={{
          location: locationOptions,
          make: makeOptions,
        }}
        lockedSelectValues={
          lockedLocationValue ? { location: lockedLocationValue } : undefined
        }
        triggerVariant="outline"
        triggerLabel="Kontaktformular"
        triggerClassName="w-full sm:w-auto"
        formPresentation="plain"
        showFormHeader={false}
      />
      <Button asChild variant="default" className="w-full sm:w-auto">
        <Link href={appointmentHref}>{appointmentLabel}</Link>
      </Button>
    </div>
  );
}
